import React from "react";
import sizeguideproduct from "../../images/size-guide.jpg";
import sizeguideaccessories from "../../images/accessories-size-guide.jpg";
import "./style.scss";

export default function SizeGuidePopup({
  show = true,
  accessories = false,
  onClickClose = () => {},
}) {
  return (
    <div className={`sizeguide ${show && "sizeguide--active"}`}>
      <button onClick={onClickClose} className="sizeguide__close">
        <i className="fas fa-times"></i>
      </button>

      <img
        alt="Size Guide"
        className="sizeguide__img"
        src={!accessories ? sizeguideproduct : sizeguideaccessories}
      ></img>
    </div>
  );
}
